import React, { Component, Fragment } from "react";
import createBemClass from "react-bem-builder";
import { Row, Col } from "../components/layout";
import { Header, Section } from "../components";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { cssTransitionClasses } from "../transitions/utilities/transition-utility";
import { z } from "zod";
import { Form, Field } from "react-final-form";
import emailjs from "@emailjs/browser";

emailjs.init(process.env.EMAIL_PUB_KEY);

const contactBlock = createBemClass("contact-section");

class ContactContainer extends Component {
  state = { messageSent: false, sending: false };

  onSubmit = async values => {
    this.setState({ ...this.state, sending: true });
    try {
      const response = await emailjs.send(
        process.env.EMAIL_SERVICE_NUMBER,
        process.env.EMAIL_TEMPLATE_ID,
        values
      );
      console.log("SUCCESS!", response.status, response.text);
    } catch (error) {
      console.error("FAILED...", error);
    } finally {
      this.setState({ messageSent: true, sending: false });
    }
  };

  render() {
    return (
      <Fragment>
        <Header />
        <TransitionGroup component={null}>
          <CSSTransition
            key={"contact-page-content"}
            classNames={cssTransitionClasses("contact-page-content")}
            appear={true}
            timeout={350}
          >
            <div>{this.renderContactSection()}</div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }

  renderContactSection() {
    const validateSchema = z.object({
      firstName: z.string(),
      lastName: z.string(),
      email: z.string().email()
    });

    const formValidator = schema => values => {
      try {
        schema.parse(values);
        return {};
      } catch (err) {
        return err.formErrors.fieldErrors;
      }
    };

    return (
      <Section className={contactBlock()}>
        <Row>
          {this.state.messageSent ? (
            <Fragment>
              <Col className={contactBlock("success")}>
                <h3>Thanks for getting in touch.</h3>
                <p>We'll get back to you as soon as we can.</p>
              </Col>
            </Fragment>
          ) : (
            <Fragment>
              <Col xs={12} md={6}>
                <h3>Contact Us</h3>
              </Col>
              <Col xs={12} md={6}>
                <Form
                  onSubmit={this.onSubmit}
                  validate={formValidator(validateSchema)}
                  render={({
                    handleSubmit,
                    submitting,
                    submitSucceeded,
                    pristine,
                    valid
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Row>
                        <Col>
                          <label htmlFor="firstName">
                            First name *
                            <Field
                              name="firstName"
                              render={({ input, meta }) => (
                                <input
                                  {...input}
                                  className={
                                    meta.error && meta.touched ? "invalid" : ""
                                  }
                                />
                              )}
                            />
                          </label>
                        </Col>
                        <Col xs={12} md={6}>
                          <label htmlFor="lastName">
                            Last name *
                            <Field
                              name="lastName"
                              render={({ input, meta }) => (
                                <input
                                  {...input}
                                  className={
                                    meta.error && meta.touched ? "invalid" : ""
                                  }
                                />
                              )}
                            />
                          </label>
                        </Col>
                      </Row>
                      <label htmlFor="company">
                        Company
                        <Field name="company" component="input" />
                      </label>
                      <label htmlFor="email">
                        Email *
                        <Field
                          name="email"
                          type="email"
                          render={({ input, meta }) => (
                            <input
                              {...input}
                              className={
                                meta.error && meta.touched ? "invalid" : ""
                              }
                            />
                          )}
                        />
                      </label>
                      <label htmlFor="mobile">
                        Mobile
                        <Field name="mobile" component="input" type="number" />
                      </label>
                      <label htmlFor="website">
                        Website
                        <Field name="website" component="input" />
                      </label>
                      <label htmlFor="query">
                        Your query
                        <Field
                          name="query"
                          render={({ input }) => (
                            <textarea {...input} rows="7" />
                          )}
                        />
                      </label>
                      <button
                        type="submit"
                        disabled={
                          submitting || pristine || !valid || submitSucceeded
                        }
                      >
                        {this.state.sending ? "Sending" : "Submit"}
                      </button>
                    </form>
                  )}
                />
              </Col>
            </Fragment>
          )}
        </Row>
      </Section>
    );
  }
}

export default ContactContainer;
